import { Link } from 'react-router-dom';

export default function AboutSection() {
  return (
    <section className="relative bg-gradient-to-b from-primary-900 via-primary-800 to-primary-900 py-20 md:py-28 px-6 md:px-12 lg:px-20">
      <div className="max-w-[1280px] mx-auto">
        {/* Label */}
        <div className="inline-flex items-center gap-2 mb-8">
          <span className="text-accent-400 text-sm tracking-[0.2em] font-sans font-light">/</span>
          <span className="text-accent-400/80 text-xs md:text-sm tracking-[0.15em] font-sans font-light">会社概要</span>
        </div>

        {/* Main Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
          {/* Left - Text Content */}
          <div className="lg:col-span-7">
            <h2 className="text-2xl md:text-4xl lg:text-5xl font-heading font-light text-white tracking-[0.06em] leading-[1.35]">
              社会インフラを支える
              <br />
              風防技術
            </h2>
            <div className="mt-8 space-y-5 text-sm md:text-base text-foreground-200/80 tracking-[0.06em] leading-[1.9] font-sans font-light max-w-xl">
              <p>
                株式会社バンクカード・チェックは、2015年の創業以来、AIとビッグデータ分析技術を駆使し、金融機関のカード不正利用対策を支援してまいりました。
              </p>
              <p>
                年間10億件以上のカード取引データをリアルタイムで監視し、ディープラーニングによる異常検知アルゴリズムで99.8%の精度を実現。金融庁ガイドラインに完全準拠したセキュリティ基盤を提供しています。
              </p>
              <p>
                東京・丸の内に本社を構え、大阪、福岡、シンガポールの4拠点で24時間365日の監視体制を敷き、国内主要金融機関をはじめ50社以上の企業にサービスを提供しています。
              </p>
            </div>
          </div>

          {/* Right - Image + Year + CTA */}
          <div className="lg:col-span-5 space-y-8">
            {/* Office Image */}
            <div className="relative w-full aspect-[4/3] rounded-lg overflow-hidden bg-background-200/10">
              <img
                src="https://readdy.ai/api/search-image?query=Professional%20architectural%20photography%20of%20a%20modern%20glass%20office%20building%20exterior%20in%20Marunouchi%20Tokyo%2C%20reflective%20glass%20facade%2C%20clean%20lines%2C%20corporate%20Japan%20business%20district%2C%20afternoon%20natural%20lighting%2C%20blue%20sky%20with%20subtle%20clouds%2C%20premium%20real%20estate%2C%20no%20text%2C%20minimal%20composition&width=800&height=600&seq=about-office-marunouchi&orientation=landscape"
                alt="丸の内オフィス外観"
                className="w-full h-full object-cover object-top"
              />
            </div>

            {/* Stats */}
            <div className="flex items-end gap-4">
              <span className="text-7xl md:text-8xl font-heading font-light text-white tracking-tight leading-none">2015</span>
              <span className="text-sm text-foreground-300 tracking-[0.08em] font-sans font-light pb-2">創業</span>
            </div>

            <p className="text-sm md:text-base text-foreground-200/70 tracking-[0.06em] leading-relaxed font-sans font-light">
              代表取締役社長 佐藤健一のもと、累計10億件のカード取引を監視。
              <br />
              金融の安全を、技術の力で守り続けています。
            </p>

            <Link
              to="/services"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-full border border-white/30 text-white text-sm tracking-[0.08em] font-sans font-light hover:bg-white/10 hover:border-white/50 transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              詳細な沿革を見る
              <i className="ri-arrow-right-line text-base" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}